// extracted by mini-css-extract-plugin
export default {"font-comfortaa":"PageTitle_font-comfortaa__uJ786","font-default":"PageTitle_font-default__9bRJs"};